import { render, staticRenderFns } from "./ModalSupportedStudyVersions.vue?vue&type=template&id=ca994f78&"
import script from "./ModalSupportedStudyVersions.vue?vue&type=script&lang=js&"
export * from "./ModalSupportedStudyVersions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports